
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvServiceBookingView.html?raw';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { EvServiceBookingTypes } from "../_loadingHelpers/EvService"
import "../../moreCore/UI/CheckBox/CheckBox";
import CheckBox from '../../moreCore/UI/CheckBox/CheckBox';
class EvServiceBookingView extends compose(_StatefulSection) {
    templateString: any = template;

    private cbYesNo: MdsLax<InstanceType<typeof CheckBox>>;

    afterSetData() {
        let data = this.currentData as EvServiceBookingTypes.EvServiceBookingEntity;

        this.cbYesNo.setLabel(this.getAttributeValue("service_txt"));

        //console.log(this.id + " data", data);
    }



    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvServiceBookingView);